import seaways from 'seaways'
import { axiosClient } from '../../services/axios-client'

const http = seaways.createClient(axiosClient)

http.account = { method: 'get', path: '/account/info' }
http.invouces = { method: 'get', path: '/account/invoices' }
http.paymentPlan = { method: 'get', path: '/account/plan/info' }

http.emailUpdate = { method: 'post', path: '/account/email' }
http.paymentMethodUpdate = {
  method: 'post',
  path: '/payment/payment-method'
}

async function me() {
  return (await http.account()).data
}

async function invoices() {
  return (await http.invouces()).data
}

async function paymentPlan() {
  return (await http.paymentPlan()).data
}

async function emailUpdate(data) {
  return (await http.emailUpdate({ data })).data
}

async function paymentMethodUpdate(data) {
  return (await http.paymentMethodUpdate({ data })).data
}

export default {
  me,
  invoices,
  paymentPlan,

  emailUpdate,
  paymentMethodUpdate
}
